import { MenuItem, MenuList } from '@material-tailwind/react';
import React from 'react'

const menuItems = [
    { name: 'Méthodologie NextMaker', link: '#' },
    { name: 'Disciplines', link: '/courses-list' },
    { name: 'Nos tuteurs', link: '/instructors-list' },
    { name: 'Summer Maker Stage ', link: '#' },
    { name: 'Offre Ecoles', link: '#' }
];

function EnSavoirPlus({ mobile = false }) {
    return (
        <MenuList className={`${mobile ? 'w-full mt-1' : 'min-w-[180px]'} z-[100] p-2 dark:bg-dark-1 rounded-lg shadow-lg`}>
            {menuItems.map((item, index) => (
                <a href={item.link} key={index}>
                    <MenuItem
                        className='hover:bg-blue-50 hover:text-blue-600 w-full px-4 py-3 text-sm text-dark-1
                        dark:text-white dark:hover:bg-dark-3 dark:hover:text-blue-400 transition-colors
                        rounded-md flex items-center'
                    >
                        {item.name}
                    </MenuItem>
                </a>
            ))}
        </MenuList>
    )
}

export default EnSavoirPlus